import { useEffect, useRef } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { NetworkingFormData } from '../index';

type UseTrunkedModeParams = {
  watch: UseFormMethods<NetworkingFormData>['watch'];
  setValue: UseFormMethods<NetworkingFormData>['setValue'];
  trigger: UseFormMethods<NetworkingFormData>['trigger'];
};

export const useTrunkedMode = ({
  watch,
  setValue,
  trigger,
}: UseTrunkedModeParams): boolean => {
  const watchTrunked = watch('trunked');
  const isTrunked = watchTrunked === true;
  const prevTrunkedRef = useRef(watchTrunked);

  useEffect(() => {
    if (isTrunked) {
      setValue('assignDhcp', false, {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue('ipAddress', '', {
        shouldDirty: true,
        shouldValidate: true,
      });
    }

    if (prevTrunkedRef.current === false && isTrunked) {
      trigger(['trunkedNetworks', 'networkName', 'ipAddress']);
    }

    prevTrunkedRef.current = watchTrunked;
  }, [watchTrunked, setValue, isTrunked, trigger]);

  return isTrunked;
};
